module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Appliquer","flags":["TRACK"],"track":"Apply"}}